import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      $( `
      .js-fade:not(.js-ignore),
      .js-reveal:not(.js-ignore),
      .js-fade-group,
      .wysiwyg--animate,
      .js-split-lines
      ` ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              if ( $( this ).hasClass( 'js-fade-group' ) ) {
                $( this ).find( '> *' ).each( function( childKey, child ) {
                  const delay = ( childKey + 1 ) / 10;
                  child.style.setProperty( '--fade-group-delay', delay + 's' );
                } );
              }
              $( this ).addClass( 'js-animated' );
            },
          },
        } );
      } );

      const splitClasses = '.js-split-lines:not(.js-ignore), .wysiwyg--animate [class*="hdg-"], .wysiwyg--animate h1, .wysiwyg--animate h2, .wysiwyg--animate h3, .wysiwyg--animate h4, .wysiwyg--animate h5, .wysiwyg--animate h6';
      const splitInstances = [];

      function initSplits() {
        // Clean up old splits
        splitInstances.forEach( ( instance ) => instance.revert() );
        splitInstances.length = 0;

        // Kill old ScrollTriggers for split elements
        ScrollTrigger.getAll().forEach( ( st ) => {
          if ( st.trigger && st.trigger.matches( splitClasses ) ) {
            st.kill();
          }
        } );

        document.querySelectorAll( splitClasses ).forEach( ( el ) => {
          const childSplit = new SplitText( el, {
            type: 'lines',
            linesClass: 'line--child',
            reduceWhiteSpace: false,
          } );

          const parentSplit = new SplitText( el, {
            type: 'lines',
            linesClass: 'line--parent',
            reduceWhiteSpace: false,
          } );

          splitInstances.push( childSplit, parentSplit );

          el.classList.add( 'js-split-words--target' );

          gsap.from( childSplit.lines, {
            yPercent: 200,
            duration: 1.5,
            stagger: 0.1,
            ease: 'power4.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',
              toggleActions: 'play none none none',
              onEnter: () => el.classList.add( 'js-animated' ),
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  el.classList.add( 'js-animated' );
                }
              },
            },
          } );
        } );

        ScrollTrigger.refresh();
      }


      let lastWidth = window.innerWidth;
      let resizeTimeout;

      window.addEventListener( 'resize', () => {
        const currentWidth = window.innerWidth;

        // Ignore mobile URL bar / height-only changes
        if ( currentWidth === lastWidth ) return;

        lastWidth = currentWidth;

        clearTimeout( resizeTimeout );
        resizeTimeout = setTimeout( () => {
          initSplits();
        }, 250 );
      } );


      initSplits();
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
